
<template>

	<myframe title="Фильтры" without_border without_margin>

		<div v-if="!data.not_editable && check_roles([ 'group_tree' ])" class="d-flex mt-2" style="gap: .5rem;">
			<v-select :clearable="false" label="name" :options="filters_visible" v-model="new_filter" :reduce="obj => obj.id" clearSearchOnSelect :tabindex="-1" style="flex: 1;"/>

			<b-button v-if="new_filter != null" size="sm" variant="outline-primary" v-on:click="() => add_one()"><base-icon name="add"/></b-button>
		</div>

		<b-table class="mt-2" :items="data.filters" :fields="fields" sort-by="date">
			<template v-slot:head(settings)>

				<base-icon name="settings" />

			</template>

			<template v-slot:cell(settings)="data">

				<b-button variant="outline-primary-dark" size="sm" @click="() => delete_one(data.item.id)">

					<base-icon name="delete"  />

				</b-button>

			</template>
		</b-table>

	</myframe>

</template>

<script>

import api from "../../../api"
import myframe from "../../widgets/frame"

export default
{
	props :
	{
		id : String,
		data : Object,
	},

	components :
	{
		myframe,
	},

	data()
	{
		return {
			
			service : "cadastral_groups",

			filters : [],
			filters_visible : [],
			new_filter : null
		}
	},

	computed :
	{
		fields()
		{
			let attrs = [ { key : "name", label : "Название" } ]

			if (this.check_roles([ 'group_tree' ]) && !this.$root.not_editable)
			{
				attrs.unshift({
					key : "settings",
					label : "",
					thClass: "cell_settings_head",
					thStyle : "width: 64px;"
				})

			}

			return attrs
		}

	},

	watch :
	{
		data :
		{
			immediate : true,
			handler(data)
			{
				if(data)
					this.update_filters_visible(data)
			}
		}
	},

	created()
	{
		api.call(this, "filters", "get_many", { is_raw : true },
			response =>
			{
				this.filters = api.sort_objects_array_by_key(response.data, "name")

				this.update_filters_visible(null, response.data)
			})
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		update_filters_visible(data = null, filters = null)
		{
			if(data == null)
				data = this.data

			if(filters == null)
				filters = this.filters

			if(data.filters != null)
				this.filters_visible = filters.filter(flt => data.filters.find(group_flt => group_flt.id == flt.id) == null)
		},

		add_one()
		{
			api.call(this, this.service, "add_to_set", { id : this.id, array : "filters", value : this.new_filter },
				() =>
				{
					this.$emit("need_refresh")
					this.new_filter = null
				})
		},

		delete_one(flt_id)
		{
			const message = "Вы действительно хотите удалить фильтр из группы? После удаления потребуется группировка объектов."

			this.$bvModal.msgBoxConfirm(message,
				{
					title : "Подтверждение удаления",
					okVariant : "danger",
					okTitle : "Да",
					cancelVariant : "outline-primary-secondary",
					cancelTitle : "Нет",
					hideHeaderClose : false,
					centered : true
				})
				.then(
					value =>
					{
						if(value)
							api.call(this, this.service, "delete_from_array", { id : this.id, array : "filters", value : flt_id }, () => this.$emit("need_refresh"))
					})
		}
	}
}

</script>

<style scoped>
* >>> .cell_settings_head
{
	text-align: center;
}
</style>

